// Module
var code = "<h2>Assignment 2 description</h2> <p>Submit:</p> <ol> <li>User profiles</li> </ol>";
// Exports
export default code;